export const IMAGE_WIDTH = 1280
export const IMAGE_HEIGHT = 720
